// extracted by mini-css-extract-plugin
module.exports = {"logo":"brand_logo_logo__8Q8Zv","responsive-stacked":"brand_logo_responsive-stacked__5aNPN","responsive-horizontal":"brand_logo_responsive-horizontal__rhkMR"};